module.exports = __webpack_public_path__ + "img/activities.b3410829.svg";